module.exports = __webpack_public_path__ + "img/appbar.34ebf5c5.jpg";